<div class="c-card">
	<div class="c-content u-no-p@up-to-md" [ngStyle]="vm.loading && {'min-height': '300px'}">
		<table-consents [consents]="vm.consents" [pageSize]="vm.pageSize" [currentPage]="vm.currentPage" *ngIf="!vm.loading && vm.consents?.length" (currentPageChange)="vm.currentPageChanged($event)"></table-consents>
		<div class="c-content c-content--xxl" *ngIf="!vm.loading && !vm.consents?.length">
			<p class="c-text c-text--gray c-text--center c-text--lg u-ost-md">{{ 'Booking.Other.NoContent' | translate }}</p>
		</div>
		<loader-overlay *ngIf="vm.loading"></loader-overlay>
	</div>
	<div *ngIf="vm.consents && vm.consents?.length > vm.pageSize">	
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.consents?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
